// extracted by mini-css-extract-plugin
export var avatarContainer = "_ad-0";
export var avatarTypingWave = "_ad-i";
export var gray = "_ad-f";
export var green = "_ad-c";
export var icon = "_ad-9";
export var image = "_ad-1";
export var lg = "_ad-6";
export var md = "_ad-5";
export var presenceDot = "_ad-b";
export var red = "_ad-d";
export var sm = "_ad-4";
export var status = "_ad-a";
export var typingDot = "_ad-h";
export var typingPill = "_ad-g";
export var xl = "_ad-7";
export var xs = "_ad-3";
export var xxl = "_ad-8";
export var xxs = "_ad-2";
export var yellow = "_ad-e";